import { cn } from "@/primitives/utils"

/*
 * The state of something that runs by itself, such as a connection, as a dot and a word:
 * "Connected", "Needs reconnecting", "Not connected". The dot's colour keeps its token's meaning,
 * so a fault to notice is `feed-error`, never a warning, and something switched off is idle grey.
 */

const tones = {
  success: "bg-success ring-success/20",
  warning: "bg-warning ring-warning/20",
  "feed-error": "bg-feed-error ring-feed-error/20",
  idle: "bg-subtle-foreground ring-subtle-foreground/20",
} as const

export function StatusDot({ tone, label }: { tone: keyof typeof tones; label: string }) {
  return (
    <span className="inline-flex items-center gap-2 text-ui">
      <span aria-hidden className={cn("size-2 shrink-0 rounded-full ring-2", tones[tone])} />
      {label}
    </span>
  )
}
